import React from 'react'
import GridBlock from "components/GridBlock";
import TextInput from "components/TextInput";
import OrganizationInput from "components/OrganizationInput";
import PropTypes from "prop-types";
import propertyTransformer from "./history/propertyTransformer";

function PurchasingGroupStage1BasicDataForm(
    {
        formikProps,
        basicData,
        disabled,
    }) {


    return (<GridBlock
        column
    >
        <TextInput
            formikProps={formikProps}
            id="number"
            label={propertyTransformer.number.label}
            required={!basicData.numberingAutomated}
            limit={basicData.numberingAutomated ? undefined : 50}
            disabled={disabled || basicData.numberingAutomated}
        />
        <OrganizationInput
            id='organization'
            formikProps={formikProps}
            required
            disabled={disabled || basicData.availableOrganizations.length < 2}
            availableOrganizations={basicData.availableOrganizations}
        />
        <TextInput
            formikProps={formikProps}
            id="name"
            label={propertyTransformer.name.label}
            required
            limit={400}
            disabled={disabled}
            multiline
        />
        <TextInput
            formikProps={formikProps}
            id="description"
            label={propertyTransformer.description.label}
            required
            multiline
            limit={4000}
            disabled={disabled}
        />
    </GridBlock>)
}

PurchasingGroupStage1BasicDataForm.propTypes = {
    basicData: PropTypes.shape({
        purchasingGroup: PropTypes.object.isRequired,
        numberingAutomated: PropTypes.bool.isRequired,
        availableOrganizations: PropTypes.arrayOf(PropTypes.shape({
            externalId: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            orgId: PropTypes.string.isRequired,
        })).isRequired
    })
}

export default PurchasingGroupStage1BasicDataForm;